import { normalizeRedirectPath } from '@/utils/smartSalesPrivateQualityNav'

export const AI_STUDIO_ENTRY_PATH = '/smartSalesAi/aiStudio'

const REDIRECT_STORAGE_KEY = 'SMART_SALES_AI_STUDIO_REDIRECT'

export function isAiStudioEntryPath(path = '') {
  const normalized = String(path || '').split('?')[0]
  return (
    normalized === AI_STUDIO_ENTRY_PATH ||
    normalized.endsWith('/aiStudio')
  )
}

export function isAiStudioRedirect(redirect = '') {
  return isAiStudioEntryPath(normalizeRedirectPath(redirect))
}

export function isAiStudioRouteItem(item) {
  return (
    item?.meta?.title === 'AI Studio' ||
    item?.name === 'SmartSalesAiStudio' ||
    item?.name === 'SmartSalesAiStudioEntry' ||
    item?.component === 'smartSalesAi/aiStudio/index' ||
    (typeof item?.path === 'string' && item.path.includes('aiStudio'))
  )
}

export function rememberAiStudioRedirect(path = AI_STUDIO_ENTRY_PATH) {
  const target = normalizeRedirectPath(path) || AI_STUDIO_ENTRY_PATH
  try {
    sessionStorage.setItem(REDIRECT_STORAGE_KEY, target)
  } catch (e) {
    // ignore
  }
  return target
}

export function clearAiStudioRedirect() {
  try {
    sessionStorage.removeItem(REDIRECT_STORAGE_KEY)
  } catch (e) {
    // ignore
  }
}
